export default __webpack_public_path__ + "static/media/Asiacell.bb8980a9.png";